"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "prato": {
    "4e016d1c": [{
      "hkey": "30df1d28",
      "slug": "san-paolo-via-galcianese-via-pistoiese",
      "name": "San Paolo-Via Galcianese-Via Pistoiese",
      "primary": true,
      "skipSearch": false
    }],
    "borgonuovo": [{
      "hkey": "30df1d28",
      "slug": "san-paolo-via-galcianese-via-pistoiese",
      "name": "San Paolo-Via Galcianese-Via Pistoiese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prato"
    }],
    "d407c44a": [{
      "hkey": "04ef596c",
      "slug": "grignano",
      "name": "Grignano",
      "primary": true,
      "skipSearch": false
    }],
    "cafaggio": [{
      "hkey": "04ef596c",
      "slug": "grignano",
      "name": "Grignano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prato"
    }],
    "9041c1a4": [{
      "hkey": "a415b8c6",
      "slug": "galciana",
      "name": "Galciana",
      "primary": true,
      "skipSearch": false
    }],
    "capezzana": [{
      "hkey": "a415b8c6",
      "slug": "galciana",
      "name": "Galciana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prato"
    }],
    "27a05628": [{
      "hkey": "f8446bb8",
      "slug": "castellina-pieta-stazione",
      "name": "Castellina-Pietà-Stazione",
      "primary": true,
      "skipSearch": false
    }],
    "castellina": [{
      "hkey": "f8446bb8",
      "slug": "castellina-pieta-stazione",
      "name": "Castellina-Pietà-Stazione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "81c6a0bc": [{
      "hkey": "28543a53",
      "slug": "prato",
      "name": "Prato",
      "primary": true,
      "skipSearch": false
    }],
    "cerreto": [{
      "hkey": "28543a53",
      "slug": "prato",
      "name": "Prato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "13774eb3": [{
      "hkey": "30df1d28",
      "slug": "san-paolo-via-galcianese-via-pistoiese",
      "name": "San Paolo-Via Galcianese-Via Pistoiese",
      "primary": true,
      "skipSearch": false
    }],
    "china-town": [{
      "hkey": "30df1d28",
      "slug": "san-paolo-via-galcianese-via-pistoiese",
      "name": "San Paolo-Via Galcianese-Via Pistoiese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prato"
    }],
    "ed10153a": [{
      "hkey": "23a65957",
      "slug": "mercato-nuovo-sacro-cuore",
      "name": "Mercato Nuovo-Sacro Cuore",
      "primary": true,
      "skipSearch": false
    }],
    "ciliani": [{
      "hkey": "23a65957",
      "slug": "mercato-nuovo-sacro-cuore",
      "name": "Mercato Nuovo-Sacro Cuore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prato"
    }],
    "dec54113": [{
      "hkey": "ef708ff1",
      "slug": "coiano-santa-lucia",
      "name": "Coiano-Santa Lucia",
      "primary": true,
      "skipSearch": false
    }],
    "coiano": [{
      "hkey": "ef708ff1",
      "slug": "coiano-santa-lucia",
      "name": "Coiano-Santa Lucia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8ca59cd9": [{
      "hkey": "28543a53",
      "slug": "prato",
      "name": "Prato",
      "primary": true,
      "skipSearch": false
    }],
    "collina-di-prato": [{
      "hkey": "28543a53",
      "slug": "prato",
      "name": "Prato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "90dceca5": [{
      "hkey": "28543a53",
      "slug": "prato",
      "name": "Prato",
      "primary": true,
      "skipSearch": false
    }],
    "colonica": [{
      "hkey": "28543a53",
      "slug": "prato",
      "name": "Prato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "da1961b9": [{
      "hkey": "6e6e988a",
      "slug": "repubblica-valentini-zarini",
      "name": "Repubblica-Valentini-Zarini",
      "primary": true,
      "skipSearch": false
    }],
    "ferrucci": [{
      "hkey": "6e6e988a",
      "slug": "repubblica-valentini-zarini",
      "name": "Repubblica-Valentini-Zarini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prato"
    }],
    "7eb5340e": [{
      "hkey": "a6cf1e6f",
      "slug": "filigne-galceti-villa-fiorita",
      "name": "Filigne-Galceti-Villa Fiorita",
      "primary": true,
      "skipSearch": false
    }],
    "figline": [{
      "hkey": "a6cf1e6f",
      "slug": "filigne-galceti-villa-fiorita",
      "name": "Filigne-Galceti-Villa Fiorita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "43d673b9": [{
      "hkey": "30df1d28",
      "slug": "san-paolo-via-galcianese-via-pistoiese",
      "name": "San Paolo-Via Galcianese-Via Pistoiese",
      "primary": true,
      "skipSearch": false
    }],
    "filzi": [{
      "hkey": "30df1d28",
      "slug": "san-paolo-via-galcianese-via-pistoiese",
      "name": "San Paolo-Via Galcianese-Via Pistoiese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prato"
    }],
    "58fe72ea": [{
      "hkey": "a6cf1e6f",
      "slug": "filigne-galceti-villa-fiorita",
      "name": "Filigne-Galceti-Villa Fiorita",
      "primary": true,
      "skipSearch": false
    }],
    "galceti": [{
      "hkey": "a6cf1e6f",
      "slug": "filigne-galceti-villa-fiorita",
      "name": "Filigne-Galceti-Villa Fiorita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prato"
    }],
    "a4190af5": [{
      "hkey": "30df1d28",
      "slug": "san-paolo-via-galcianese-via-pistoiese",
      "name": "San Paolo-Via Galcianese-Via Pistoiese",
      "primary": true,
      "skipSearch": false
    }],
    "galcianese": [{
      "hkey": "30df1d28",
      "slug": "san-paolo-via-galcianese-via-pistoiese",
      "name": "San Paolo-Via Galcianese-Via Pistoiese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prato"
    }],
    "69a0c553": [{
      "hkey": "23a65957",
      "slug": "mercato-nuovo-sacro-cuore",
      "name": "Mercato Nuovo-Sacro Cuore",
      "primary": true,
      "skipSearch": false
    }],
    "galilei": [{
      "hkey": "23a65957",
      "slug": "mercato-nuovo-sacro-cuore",
      "name": "Mercato Nuovo-Sacro Cuore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prato"
    }],
    "97f4b025": [{
      "hkey": "f8446bb8",
      "slug": "castellina-pieta-stazione",
      "name": "Castellina-Pietà-Stazione",
      "primary": true,
      "skipSearch": false
    }],
    "giolica": [{
      "hkey": "f8446bb8",
      "slug": "castellina-pieta-stazione",
      "name": "Castellina-Pietà-Stazione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prato"
    }],
    "f040fc69": [{
      "hkey": "30df1d28",
      "slug": "san-paolo-via-galcianese-via-pistoiese",
      "name": "San Paolo-Via Galcianese-Via Pistoiese",
      "primary": true,
      "skipSearch": false
    }],
    "il-pino": [{
      "hkey": "30df1d28",
      "slug": "san-paolo-via-galcianese-via-pistoiese",
      "name": "San Paolo-Via Galcianese-Via Pistoiese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prato"
    }],
    "b29ef8c9": [{
      "hkey": "183da017",
      "slug": "la-macine-la-querce",
      "name": "La Macine-La Querce",
      "primary": true,
      "skipSearch": false
    }],
    "la-macine": [{
      "hkey": "183da017",
      "slug": "la-macine-la-querce",
      "name": "La Macine-La Querce",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "85a332bc": [{
      "hkey": "183da017",
      "slug": "la-macine-la-querce",
      "name": "La Macine-La Querce",
      "primary": true,
      "skipSearch": false
    }],
    "la-querce": [{
      "hkey": "183da017",
      "slug": "la-macine-la-querce",
      "name": "La Macine-La Querce",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prato"
    }],
    "c36b5884": [{
      "hkey": "28543a53",
      "slug": "prato",
      "name": "Prato",
      "primary": true,
      "skipSearch": false
    }],
    "le-cascine": [{
      "hkey": "28543a53",
      "slug": "prato",
      "name": "Prato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4e55c0ed": [{
      "hkey": "60c03370",
      "slug": "san-giorgio-a-colonica-santa-maria-a-colonica",
      "name": "San Giorgio a Colonica-Santa Maria a Colonica",
      "primary": true,
      "skipSearch": false
    }],
    "macrolotto": [{
      "hkey": "60c03370",
      "slug": "san-giorgio-a-colonica-santa-maria-a-colonica",
      "name": "San Giorgio a Colonica-Santa Maria a Colonica",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prato"
    }],
    "a75e5507": [{
      "hkey": "6e6e988a",
      "slug": "repubblica-valentini-zarini",
      "name": "Repubblica-Valentini-Zarini",
      "primary": true,
      "skipSearch": false
    }],
    "montegrappa": [{
      "hkey": "6e6e988a",
      "slug": "repubblica-valentini-zarini",
      "name": "Repubblica-Valentini-Zarini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prato"
    }],
    "5740cda2": [{
      "hkey": "56b6bcac",
      "slug": "narnali-viaccia",
      "name": "Narnali, Viaccia",
      "primary": true,
      "skipSearch": false
    }],
    "narnali": [{
      "hkey": "56b6bcac",
      "slug": "narnali-viaccia",
      "name": "Narnali, Viaccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "75f38246": [{
      "hkey": "56b6bcac",
      "slug": "narnali-viaccia",
      "name": "Narnali, Viaccia",
      "primary": true,
      "skipSearch": false
    }],
    "ospedale": [{
      "hkey": "56b6bcac",
      "slug": "narnali-viaccia",
      "name": "Narnali, Viaccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prato"
    }],
    "5c78cc4e": [{
      "hkey": "28543a53",
      "slug": "prato",
      "name": "Prato",
      "primary": true,
      "skipSearch": false
    }],
    "pacciana-lastre": [{
      "hkey": "28543a53",
      "slug": "prato",
      "name": "Prato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8640aea9": [{
      "hkey": "28543a53",
      "slug": "prato",
      "name": "Prato",
      "primary": true,
      "skipSearch": false
    }],
    "periferia": [{
      "hkey": "28543a53",
      "slug": "prato",
      "name": "Prato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "703e9019": [{
      "hkey": "f8446bb8",
      "slug": "castellina-pieta-stazione",
      "name": "Castellina-Pietà-Stazione",
      "primary": true,
      "skipSearch": false
    }],
    "pieta": [{
      "hkey": "f8446bb8",
      "slug": "castellina-pieta-stazione",
      "name": "Castellina-Pietà-Stazione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prato"
    }],
    "249ee913": [{
      "hkey": "6e6e988a",
      "slug": "repubblica-valentini-zarini",
      "name": "Repubblica-Valentini-Zarini",
      "primary": true,
      "skipSearch": false
    }],
    "repubblica": [{
      "hkey": "6e6e988a",
      "slug": "repubblica-valentini-zarini",
      "name": "Repubblica-Valentini-Zarini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a970cf02": [{
      "hkey": "f8446bb8",
      "slug": "castellina-pieta-stazione",
      "name": "Castellina-Pietà-Stazione",
      "primary": true,
      "skipSearch": false
    }],
    "sacra-famiglia": [{
      "hkey": "f8446bb8",
      "slug": "castellina-pieta-stazione",
      "name": "Castellina-Pietà-Stazione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prato"
    }],
    "2624b51e": [{
      "hkey": "23a65957",
      "slug": "mercato-nuovo-sacro-cuore",
      "name": "Mercato Nuovo-Sacro Cuore",
      "primary": true,
      "skipSearch": false
    }],
    "sacrocuore": [{
      "hkey": "23a65957",
      "slug": "mercato-nuovo-sacro-cuore",
      "name": "Mercato Nuovo-Sacro Cuore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e0618001": [{
      "hkey": "60c03370",
      "slug": "san-giorgio-a-colonica-santa-maria-a-colonica",
      "name": "San Giorgio a Colonica-Santa Maria a Colonica",
      "primary": true,
      "skipSearch": false
    }],
    "san-giorgio-a-colonica": [{
      "hkey": "60c03370",
      "slug": "san-giorgio-a-colonica-santa-maria-a-colonica",
      "name": "San Giorgio a Colonica-Santa Maria a Colonica",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "32771cb5": [{
      "hkey": "1ce87d0c",
      "slug": "centro-storico",
      "name": "Centro storico",
      "primary": true,
      "skipSearch": false
    }],
    "san-marco": [{
      "hkey": "1ce87d0c",
      "slug": "centro-storico",
      "name": "Centro storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prato"
    }],
    "0b4bc155": [{
      "hkey": "23a65957",
      "slug": "mercato-nuovo-sacro-cuore",
      "name": "Mercato Nuovo-Sacro Cuore",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino": [{
      "hkey": "23a65957",
      "slug": "mercato-nuovo-sacro-cuore",
      "name": "Mercato Nuovo-Sacro Cuore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prato"
    }],
    "3df6d573": [{
      "hkey": "30df1d28",
      "slug": "san-paolo-via-galcianese-via-pistoiese",
      "name": "San Paolo-Via Galcianese-Via Pistoiese",
      "primary": true,
      "skipSearch": false
    }],
    "san-paolo": [{
      "hkey": "30df1d28",
      "slug": "san-paolo-via-galcianese-via-pistoiese",
      "name": "San Paolo-Via Galcianese-Via Pistoiese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "38305a15": [{
      "hkey": "ef708ff1",
      "slug": "coiano-santa-lucia",
      "name": "Coiano-Santa Lucia",
      "primary": true,
      "skipSearch": false
    }],
    "santa-lucia": [{
      "hkey": "ef708ff1",
      "slug": "coiano-santa-lucia",
      "name": "Coiano-Santa Lucia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prato"
    }],
    "bcdfe495": [{
      "hkey": "60c03370",
      "slug": "san-giorgio-a-colonica-santa-maria-a-colonica",
      "name": "San Giorgio a Colonica-Santa Maria a Colonica",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria-a-colonica": [{
      "hkey": "60c03370",
      "slug": "san-giorgio-a-colonica-santa-maria-a-colonica",
      "name": "San Giorgio a Colonica-Santa Maria a Colonica",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prato"
    }],
    "c3ae47e7": [{
      "hkey": "7c269120",
      "slug": "chiesanuova",
      "name": "Chiesanuova",
      "primary": true,
      "skipSearch": false
    }],
    "stadio": [{
      "hkey": "7c269120",
      "slug": "chiesanuova",
      "name": "Chiesanuova",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prato"
    }],
    "c867d2d4": [{
      "hkey": "f8446bb8",
      "slug": "castellina-pieta-stazione",
      "name": "Castellina-Pietà-Stazione",
      "primary": true,
      "skipSearch": false
    }],
    "stazione": [{
      "hkey": "f8446bb8",
      "slug": "castellina-pieta-stazione",
      "name": "Castellina-Pietà-Stazione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prato"
    }],
    "0543f1ee": [{
      "hkey": "1d90c4c2",
      "slug": "vergaio-tobbiana",
      "name": "Vergaio-Tobbiana",
      "primary": true,
      "skipSearch": false
    }],
    "tobbiana": [{
      "hkey": "1d90c4c2",
      "slug": "vergaio-tobbiana",
      "name": "Vergaio-Tobbiana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prato"
    }],
    "16b5b9d2": [{
      "hkey": "6e6e988a",
      "slug": "repubblica-valentini-zarini",
      "name": "Repubblica-Valentini-Zarini",
      "primary": true,
      "skipSearch": false
    }],
    "valentini": [{
      "hkey": "6e6e988a",
      "slug": "repubblica-valentini-zarini",
      "name": "Repubblica-Valentini-Zarini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prato"
    }],
    "56b09eb2": [{
      "hkey": "1d90c4c2",
      "slug": "vergaio-tobbiana",
      "name": "Vergaio-Tobbiana",
      "primary": true,
      "skipSearch": false
    }],
    "vergaio": [{
      "hkey": "1d90c4c2",
      "slug": "vergaio-tobbiana",
      "name": "Vergaio-Tobbiana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5f121af9": [{
      "hkey": "28543a53",
      "slug": "prato",
      "name": "Prato",
      "primary": true,
      "skipSearch": false
    }],
    "via-filzi": [{
      "hkey": "28543a53",
      "slug": "prato",
      "name": "Prato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c5cfdb2f": [{
      "hkey": "183da017",
      "slug": "la-macine-la-querce",
      "name": "La Macine-La Querce",
      "primary": true,
      "skipSearch": false
    }],
    "via-firenze": [{
      "hkey": "183da017",
      "slug": "la-macine-la-querce",
      "name": "La Macine-La Querce",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prato"
    }],
    "218ce7fc": [{
      "hkey": "30df1d28",
      "slug": "san-paolo-via-galcianese-via-pistoiese",
      "name": "San Paolo-Via Galcianese-Via Pistoiese",
      "primary": true,
      "skipSearch": false
    }],
    "via-pistoiese": [{
      "hkey": "30df1d28",
      "slug": "san-paolo-via-galcianese-via-pistoiese",
      "name": "San Paolo-Via Galcianese-Via Pistoiese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prato"
    }],
    "6a4d4f61": [{
      "hkey": "56b6bcac",
      "slug": "narnali-viaccia",
      "name": "Narnali, Viaccia",
      "primary": true,
      "skipSearch": false
    }],
    "viaccia": [{
      "hkey": "56b6bcac",
      "slug": "narnali-viaccia",
      "name": "Narnali, Viaccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prato"
    }],
    "8d44e4d7": [{
      "hkey": "a6cf1e6f",
      "slug": "filigne-galceti-villa-fiorita",
      "name": "Filigne-Galceti-Villa Fiorita",
      "primary": true,
      "skipSearch": false
    }],
    "villa-fiorita": [{
      "hkey": "a6cf1e6f",
      "slug": "filigne-galceti-villa-fiorita",
      "name": "Filigne-Galceti-Villa Fiorita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prato"
    }],
    "2a7e08b3": [{
      "hkey": "6e6e988a",
      "slug": "repubblica-valentini-zarini",
      "name": "Repubblica-Valentini-Zarini",
      "primary": true,
      "skipSearch": false
    }],
    "zarini": [{
      "hkey": "6e6e988a",
      "slug": "repubblica-valentini-zarini",
      "name": "Repubblica-Valentini-Zarini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prato"
    }]
  }
};
exports["default"] = _default;